import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import Modal from "../../../modal";
import { FaAngleDown } from "react-icons/fa6";
import { Dropdown, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetExpense,
  UpdateExpenses,
} from "../../../../redux/Transaction/action";
import useInfiniteScroll from "../../../Hooks/useInfiniteScroll";
import dayjs from "dayjs";
import NoData from "../../../noData";
import { generatePopup } from "../../../../utility/popup";

const ExpenseTable = ({ searchValue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [expensesData, setExpensesData] = useState();
  const [selectedSale, setSelectedSale] = useState(null); // State for selected sale
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });
  const [hasMoreData, setHasMoreData] = useState(true);

  const expenseData = useSelector((state) => state?.Sale?.expenseData?.data);

  const openModal = (purchase) => {
    setSelectedSale(purchase);
    setIsOpen(true);
  };
  const closeModal = () => {
    setSelectedSale(null); // Reset selected sale
    setIsOpen(false);
  };

  const handleApproval = () => {
    let obj = {
      date: selectedSale?.date,
      vatamount: selectedSale?.vatamount,
      nonvatamount: selectedSale?.nonvatamount,
      title: selectedSale?.title,
      paymentmethod: selectedSale?.paymentmethod?._id,
      description: selectedSale?.description,
      status: selectedSale?.status ? false : true,
      totalamount: selectedSale?.vatamount + selectedSale?.nonvatamount,
    };
    dispatch(UpdateExpenses({ id: selectedSale?._id, data: obj })).then(
      (res) => {
        if (res?.status === 200) {
          dispatch(
            GetExpense({
              page: filter?.page,
              limit: filter?.limit,
              storeName: searchValue,
            })
          );
        } else if (res?.data?.status === 401) {
          navigate("/");
        } else if (res?.data?.status === 400) {
          generatePopup("error", res?.data?.message);
        }
      }
    );
    closeModal();
  };

  const tableHeading = {
    no: <div className="ml-5 text-center">No.</div>,
    store: <div className="px-2 text-left">Store</div>,
    date: <div className="text-center">Date</div>,
    vatAmount: <div className="text-center">VAT Amount</div>,
    title: <div className="px-2">Title</div>,
    description: <div className="px-2">Description</div>,
    paymentMethod: <div className="text-center">Payment Method</div>,
    status: <div className=" text-center mr-5">Status</div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = expensesData?.map((e, index) => {
    const status = e?.status ? "Approved" : "Pending";
    const items = [
      {
        label: e?.status ? "Pending" : "Approve",
        key: e?.status ? "pending" : "approve",
        icon: <img src="/images/checkCircle.svg" alt="" />,
      },
    ];
    const menuProps = {
      items,
      onClick: () => openModal(e),
    };

    return {
      no: <div className="ml-5 text-center">{index + 1}</div>,
      store: <div className="px-2 text-left">{e?.createdBy?.user?.name}</div>,
      date: (
        <div className="text-center">{dayjs(e?.date).format("DD/MM/YYYY")}</div>
      ),
      vatAmount: <div className="text-center">{e?.vatamount}</div>,
      title: <div className="px-2">{e?.title}</div>,
      description: (
        <Tooltip
          color="white"
          arrow={false}
          placement="bottomLeft"
          title={e?.description}
          overlayInnerStyle={{ color: "black" }}
        >
          {e?.description.length > 30
            ? `${e?.description.slice(0, 30)}...`
            : e?.description}
        </Tooltip>
      ),
      paymentMethod: (
        <div className="text-center">{e?.paymentmethod?.paymentmethod}</div>
      ),
      status: (
        <div className="flex items-center justify-center px-2">
          <Dropdown placement="bottomRight" menu={menuProps}>
            <div
              className={`${
                e?.status
                  ? "text-green bg-green/10"
                  : "text-textyellow bg-bgyellow"
              } w-[90px] text-xs font-normal rounded px-1.5 py-2 flex justify-center items-center gap-1 cursor-pointer`}
            >
              {status}
              <FaAngleDown className="duration-500" />
            </div>
          </Dropdown>
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(
      GetExpense({
        page: filter?.page,
        limit: filter?.limit,
        storeName: searchValue,
      })
    ).then((res) => {
      if (res.data?.status === 401) {
        navigate("/");
      }
      if (res?.data?.data?.length === 0) {
        setHasMoreData(false);
      }
    });
  }, [dispatch, navigate, filter, searchValue]);

  useEffect(() => {
    setExpensesData(expenseData);
  }, [expenseData]);

  return (
    <>
      {bodyData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
      <Modal
        modalWidth="w-1/3"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        imgSrc="/images/approval.svg"
        title="Approval"
        btn1="No I Don’t"
        btn2="Yes I Do"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Would you like to approve this store?
          </p>
        }
        handleBtn2={handleApproval}
      />
    </>
  );
};

export default ExpenseTable;
